import API from '@/utils/ApiConfig'
import { getAxios } from '@/utils/Utils'

const processResponse = res => {
  if (res.meta.code === 200) {
    return res.data
  }
}

export default {
  getAllTermsInfo: (lang = 1) => getAxios().get(API.SERVER + API.TERMS_GET, { ...API.CONFIG, ...{ params: { language: lang } } })
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getResources: (params = {}) => getAxios().get(API.SERVER + API.MANUAL_RESOURCES_GET, { params }, API.CONFIG)
    .then(res => { return { resources: res.data.data, pagination: res.data.pagination } })
    .catch(err => { throw err }),

  getResource: (resourceId) => getAxios().get(API.SERVER + API.MANUAL_RESOURCE_GET.replace(':resourceId', resourceId), {}, API.CONFIG)
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getDayInfo: (dayId, lang = 1) => getAxios().get(API.SERVER + API.MANUAL_DAY_GET.replace(':dayId', dayId), { ...API.CONFIG, ...{ params: { language: lang } } })
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getUnitInfo: (unitId, lang = 1) => getAxios().get(API.SERVER + API.MANUAL_UNIT_GET.replace(':unitId', unitId), { ...API.CONFIG, ...{ params: { language: lang } } })
    .then(res => processResponse(res.data))
    .catch(err => { throw err }),

  getSearch: (params = {}) => getAxios().get(API.SERVER + API.MANUAL_SEARCH_GET, { params }, API.CONFIG)
    .then(res => { return { search: res.data.data, pagination: res.data.pagination } })
    .catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/services/ManualService.js